// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e6474cb3","977":"bd724c65"}[chunkId] + ".chunk.js";
};